<template>
  <v-row justify="center" align="stretch" dense>
    <v-col cols="12" lg="4">
      <Lottie
        :podcast="true"
        data-aos="fade-up"
        data-aos-easing="ease"
        data-aos-duration="1000"
        data-aos-once="true"
      />
      <audio
        controls
        style="width: 100%; background-color: #f2f2f2; border-radius: 4px"
      >
        <source src="@/assets/modulo_01/podcasts/audio_3.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      <v-btn
        block
        color="primary"
        depressed
        class="white--text"
        @click="showTranscription = !showTranscription"
      >
        <div>Visualizar transcrição</div>
      </v-btn>
    </v-col>

    <v-col cols="12" lg="8" v-if="showTranscription" class="pt-0 pb-0 pr-0 pl-1">
      <TextBlock style="height: 100%;">
        <Paragraph
          class="px-8 py-7 rounded-lg"
          style="overflow: auto; height: 100%; background: white; color: #333;"
        >
        É essencial lembrar que tanto <strong>parar</strong> quanto <strong>estacionar</strong> têm regras específicas que devem ser seguidas, sempre visando à segurança e à fluidez do trânsito. Estar atento a essas normas faz toda a diferença no dia a dia! Em situações de emergência, quando for necessário parar o veículo na via, é fundamental providenciar imediatamente a sinalização de emergência. Acione as luzes de advertência (pisca-alerta) assim que possível e posicione o triângulo de sinalização a, no mínimo, <strong>30 metros</strong> da parte traseira do veículo.
        </Paragraph>
      </TextBlock>
    </v-col>
  </v-row>
</template>

<script>
import TextBlock from "@/components/TextBlock.vue";
import Paragraph from "@/components/Paragraph.vue";
import Lottie from "@/components/Lottie.vue";

export default {
  components: {
    TextBlock,
    Paragraph,
    Lottie,
  },
  data() {
    return {
      showTranscription: false,
    };
  },

  methods: {},
};
</script>

<style scoped></style>
